const PRESERVED_KEY_SUBSTRINGS = [
  'columnVisibility',
  'columnWidths',
  // Survive logout so auto-feedback warm-up / snooze / don't-ask stay correct
  'userFeedback.',
];

export function shouldPreserveLocalStorageKey(key) {
  return PRESERVED_KEY_SUBSTRINGS.some((substr) => key.includes(substr));
}

export function snapshotPreservedLocalStorage() {
  const snapshot = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && shouldPreserveLocalStorageKey(key)) {
      snapshot[key] = localStorage.getItem(key);
    }
  }
  return snapshot;
}

export function restorePreservedLocalStorage(snapshot) {
  Object.entries(snapshot).forEach(([key, value]) => {
    if (value != null) {
      localStorage.setItem(key, value);
    }
  });
}
